import React, {useCallback, useContext} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, MenuItem, Select} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import LabelValue from "./shared/labelvalue/LabelValue";
import {containedButton, textButton} from "../utils/styles";
import FormControl from "@material-ui/core/FormControl";
import SituacaoContext from "../contexts/situacao";

const useStyles = makeStyles(theme => ({
    ...containedButton(theme, false, false),
    ...textButton(theme, false),
    root: {
        [theme.breakpoints.up('sm')]: {
            minWidth: 500
        }
    },
    contentRoot: {
        overflowY: 'initial'
    }
}));

export default function DialogFiltro(props) {
    const {
        open,
        onClose,
        title = 'Filtrar Resultados',
        onFilter
    } = props;
    const classes = useStyles();
    const {situacao, setSituacao} = useContext(SituacaoContext);

    const onChange = useCallback(event => setSituacao(event.target.value), []);

    const handleSubmit = event => {
        event.preventDefault();

        !!onFilter && onFilter();

        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            scroll='body'
            aria-labelledby={title}
            classes={{ paper: classes.root }}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent classes={{ root: classes.contentRoot }}>
                <LabelValue label='Situação'>
                    <FormControl variant="outlined" fullWidth>
                        <Select
                            name="campus"
                            variant="outlined"
                            value={situacao}
                            displayEmpty
                            onChange={onChange}>
                            <MenuItem value="" disabled>
                                <em>Selecione...</em>
                            </MenuItem>
                            <MenuItem value='T'>Todos</MenuItem>
                            <MenuItem value='N'>Em aberto</MenuItem>
                            <MenuItem value='V'>Vencidos</MenuItem>
                            <MenuItem value='A'>À vencer</MenuItem>
                            <MenuItem value='S'>Pagos</MenuItem>
                        </Select>
                    </FormControl>
                </LabelValue>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    className={classes.textButton}>
                    Fechar
                </Button>
                <Button
                    variant='contained'
                    onClick={handleSubmit}
                    className={classes.containedButton}>
                    Filtrar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

DialogFiltro.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    onFilter: PropTypes.func.isRequired
};